import { render, staticRenderFns } from "./Ticker.vue?vue&type=template&id=6cb4bd34"
import script from "./Ticker.vue?vue&type=script&lang=js"
export * from "./Ticker.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/youtube/yt-live-chat-ticker-renderer.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/css/youtube/yt-live-chat-ticker-paid-message-item-renderer.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports